/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {verifyPasskey} from '../api'

export const useMutationVerifyPasskey = createReactQueryMutationHook('verifyPasskey', verifyPasskey)
